export class AirwallexErrorCode {
    constructor(public code: string, public description: string) {}

    static codes: AirwallexErrorCode[] = [
        new AirwallexErrorCode('001', 'This field is mandatory for this request. Please specify a value and try again.'),
        new AirwallexErrorCode('002', 'Only alphanumeric characters and punctuations are accepted.'),
        new AirwallexErrorCode('003', 'Only alphanumeric characters and spaces are accepted.'),
        new AirwallexErrorCode('004', 'Only alphanumeric characters are accepted.'),
        new AirwallexErrorCode('005', 'Only alphanumeric characters, dots and dashes are accepted.'),
        new AirwallexErrorCode('006', 'Only Chinese characters and punctuation are accepted.'),
        new AirwallexErrorCode('007', 'Only Chinese characters are accepted.'),
        new AirwallexErrorCode('008', 'Only numerical values are accepted.'),
        new AirwallexErrorCode('009', 'This field cannot only contain numeric characters.'),
        new AirwallexErrorCode('010', 'Invalid value for this field.'),
        new AirwallexErrorCode('011', 'Invalid format for this field.'),
        new AirwallexErrorCode('012', 'This field cannot contain leading or trailing whitespace characters.'),
        new AirwallexErrorCode('013', 'This field cannot contain whitespace characters.'),
        new AirwallexErrorCode('014', 'This field cannot contain emojis.'),
        new AirwallexErrorCode('015', 'Only positive numerical value is accepted.'),
        new AirwallexErrorCode('016', 'Invalid value. See params for acceptable values.'),
        new AirwallexErrorCode('017', 'Invalid value. Refer to the acceptable value in params.'),
        new AirwallexErrorCode('018', 'Length outside acceptable range. See params for min and max lengths.'),
        new AirwallexErrorCode('019', 'Length mismatch. Exact length required as defined in params.'),
        new AirwallexErrorCode('020', 'Below minimum length. See params for min length.'),
        new AirwallexErrorCode('021', 'Above maximum length. See params for max length.'),
        new AirwallexErrorCode('022', 'Length does not match acceptable lengths. See params.'),
        new AirwallexErrorCode('023', 'Metadata key count exceeds limits: max 15 keys or 4500 characters.'),
        new AirwallexErrorCode('024', 'The field local_clearing_system is not applicable for SWIFT transfer_method.'),
        new AirwallexErrorCode('025', 'Date and time should be in ISO 8601 format.'),
        new AirwallexErrorCode('026', 'Date should be in ISO 8601 format.'),
        new AirwallexErrorCode('027', 'Invalid date. Must be today or later.'),
        new AirwallexErrorCode('028', 'PO Box address not accepted. Provide a street address.'),
        new AirwallexErrorCode('029', 'Provide a valid email address.'),
        new AirwallexErrorCode('030', 'Provide a valid postcode for the selected country/region.'),
        new AirwallexErrorCode('031', 'account_currency and transfer_currency mismatch.'),
        new AirwallexErrorCode('032', 'SWIFT code/BIC does not match the bank country code.'),
        new AirwallexErrorCode('033', 'Invalid SWIFT code/BIC.'),
        new AirwallexErrorCode('034', 'Specify either transfer_amount or source_amount, not both.'),
        new AirwallexErrorCode('035', 'Invalid bank code.'),
        new AirwallexErrorCode('036', 'IBAN does not match the bank country code.'),
        new AirwallexErrorCode('037', 'Transfer amount exceeds max limit. See params.'),
        new AirwallexErrorCode('038', 'Transfer amount below min limit. See params.'),
        new AirwallexErrorCode('039', 'Invalid beneficiary bank detail.'),
        new AirwallexErrorCode('040', 'Unsupported transfer method for this beneficiary.'),
        new AirwallexErrorCode('041', 'Paper check transfers not enabled for this account.'),
        new AirwallexErrorCode('042', 'Decimal places exceed max format. See params.'),
        new AirwallexErrorCode('043', 'No transfer method supported for the currency and bank country.'),
        new AirwallexErrorCode('044', 'Invalid payer ID.'),
        new AirwallexErrorCode('045', 'Invalid beneficiary ID.'),
        new AirwallexErrorCode('046', 'Specify either beneficiary ID or object, not both.'),
        new AirwallexErrorCode('047', 'Specify either payer ID or object, not both.'),
        new AirwallexErrorCode('048', 'Payer specification is unsupported.'),
        new AirwallexErrorCode('049', 'Payer age requirement not met. See params.'),
        new AirwallexErrorCode('050', 'Unexpected error. Contact support.'),
        new AirwallexErrorCode('082', 'Invalid branch code for specified bank.'),
        new AirwallexErrorCode('085', 'Invalid bank account for specified bank.'),
        new AirwallexErrorCode('086', 'Invalid or unsupported bank code. Check leading digits in params.'),
        new AirwallexErrorCode('087', 'Invalid or unsupported branch code. Check leading digits in params.'),
        new AirwallexErrorCode('088', 'Invalid transit number for specified institution.'),
        new AirwallexErrorCode('090', 'Field cannot contain only spaces.'),
        new AirwallexErrorCode('091', 'Specify either iban or bank_code & account_number under beneficiary.bank_details.'),
        new AirwallexErrorCode('092', 'Valid phone number format: +aaa-nnnnnnn.'),
        new AirwallexErrorCode('099', 'Phone number must match country code substring in params.'),
        new AirwallexErrorCode('100', 'Local phone number length must be within range in params.'),
    ];

    static getDescription(code: string): string | undefined {
        const AirwallexErrorCode = this.codes.find((error) => error.code === code);
        return AirwallexErrorCode ? AirwallexErrorCode.description : undefined;
    }
}
